module.exports = __webpack_public_path__ + "static/media/1.d695efc1.png";